import React from 'react';

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title, description }) => {
  return (
    <div className="placeholder-page">
      <div className="placeholder-card">
        <div className="placeholder-kicker">Admin Workspace</div>
        <h1 className="placeholder-title">{title}</h1>
        <p className="placeholder-description">
          {description || `${title} will be implemented here.`}
        </p>
      </div>
    </div>
  );
};

export default PlaceholderPage;
